export type FanboxColorName = 'blue' | 'yellow' | 'darkYellow' | 'pink' | 'darkPink' | 'purple' | 'midGray' | 'lightGray' | 'darkGray' | 'black' | 'white' | 'orange' | 'green';

export const FanboxColorPalette: Map<FanboxColorName, string> = (() => {
    const ret: Map<FanboxColorName, string> = new Map();
    ret.set('blue', '#6eb9ce');
    ret.set('yellow', '#ffff54');
    ret.set('darkYellow', '#d1d130');
    ret.set('pink', '#e6007e');
    ret.set('darkPink', '#92007f');
    ret.set('purple', '#563c8d');
    ret.set('midGray', '#888888');
    ret.set('lightGray', '#a0a0a0');
    ret.set('darkGray', '#131313');
    ret.set('white' , 'white');
    ret.set('black', 'black');
    ret.set('orange', '#FFB602');
    ret.set('green' , '#92CA36');

    return ret;
})();